const jumpBar = document.querySelector('.jump-bar');
const jumpBarContainer = document.querySelector('.jump-bar__container');
const header = document.querySelector('.site-header');
const main = document.querySelector('#main');

if (jumpBar && jumpBarContainer && header && main) {
  // Document Y of the container top while in its natural (absolute) position
  let containerDocTop = 0;

  function jumpBarInit() {
    const wasStuck = main.classList.contains('is-scrolled-past-header');
    const wasSticky = main.classList.contains('is-jump-bar-sticky');

    // Measure in the absolute layout so fixed positioning doesn't skew offset
    if (wasStuck) {
      main.classList.remove('is-scrolled-past-header');
    }
    if (wasSticky) {
      main.classList.remove('is-jump-bar-sticky');
    }

    containerDocTop =
      jumpBarContainer.getBoundingClientRect().top + window.scrollY;

    if (wasStuck) {
      main.classList.add('is-scrolled-past-header');
    }
    if (wasSticky) {
      main.classList.add('is-jump-bar-sticky');
    }

    jumpBarScroll();
  }

  function jumpBarScroll() {
    // Header is fixed (and translates away when compacted), so its bottom
    // edge is exactly where the jump bar should pin.
    const stickyTop = header.getBoundingClientRect().bottom;
    const containerTop = containerDocTop - window.scrollY;

    main.classList.toggle('is-scrolled-past-header', containerTop <= stickyTop);
    // Sticky class engages 10px further down the page
    main.classList.toggle('is-jump-bar-sticky', containerTop <= stickyTop - 10);
  }

  const dropdownControl = jumpBar.querySelector('.dropdown__control');

  if (dropdownControl) {
    dropdownControl.addEventListener('click', () => {
      // Runs before app.js toggles aria-expanded; skip when closing
      if (dropdownControl.getAttribute('aria-expanded') === 'true') {
        return;
      }

      // Only scroll when the menu would open in the bottom third of the viewport
      const menu = document.getElementById(
        dropdownControl.getAttribute('aria-controls')
      );
      const menuTop = (menu || dropdownControl).getBoundingClientRect().top;
      if (menuTop < window.innerHeight * (2 / 3)) {
        return;
      }

      const targetY = Math.max(0, containerDocTop - 200);

      if (window.scrollY < targetY - 1) {
        main.classList.add('is-programmatic-scroll');
        window.scrollTo({ top: targetY, behavior: 'smooth' });

        const clear = () => {
          main.classList.remove('is-programmatic-scroll');
        };

        if ('onscrollend' in window) {
          window.addEventListener('scrollend', clear, { once: true });
        } else {
          setTimeout(clear, 500);
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    jumpBarInit();
  });

  document.addEventListener('scroll', jumpBarScroll, { passive: true });

  window.addEventListener('resize', () => {
    jumpBarInit();
  });
}
